<template>
  <div id="pk-live2">
      <div class="title-box">
          <img src="@/assets/active/team-pk/title-tag.png" alt="">
          <span>{{state === '战队招募完毕' && (countDownObj.day >= 0 && countDownObj.hour >= 0 && countDownObj.minute >= 0 && countDownObj.second >= 0) ? '距离比赛结束还有' : state}}</span>
          <img src="@/assets/active/team-pk/title-tag.png" alt="">
      </div>
      <div class="timer-wrapper" v-show="countDownObj.day >= 0 && countDownObj.hour >= 0 && countDownObj.minute >= 0 && countDownObj.second >= 0">
          <div class="timer-bar">
              <span class="num">{{countDownObj.day}}</span>
              <span>日</span>
              <span class="num">{{countDownObj.hour}}</span>
              <span>时</span>
              <span class="num">{{countDownObj.minute}}</span>
              <span>分</span>
              <span class="num">{{countDownObj.second}}</span>
              <span>秒</span>
          </div>
      </div>
      <div class="live-tab-wrapper">
          <button :class="liveType === 'team' ? 'active' : ''" @click="liveType = 'team'">战队赛况</button>
          <button :class="liveType === 'person' ? 'active' : ''" @click="liveType = 'person'">个人赛况</button>
      </div>
      <p class="person-live-tip" v-show="liveType === 'person'">个人赛况仅展示当日收益率TOP10的战队成员，数据每小时更新，每日0点重新计算。</p>
      <div class="date">
          <span>数据更新时间：</span>
          <span>{{ lastTime | parseTime }}</span>
      </div>
      <div v-if="liveType === 'team'" class="list-wrapper">
          <div class="list-head clearfix">
                <div class="name left">
                    <span>战队名称</span>
                </div>
                <div class="income left">
                    <sort-btn sortType='realized' sort-name='战队收益额' @sort='sortListBy' :group-tag='sortGroup' />
                </div>
                <div class="incomeRate left">
                    <sort-btn sortType='yieldRate' sort-name='战队收益率' @sort='sortListBy' :group-tag='sortGroup' />
                </div>
          </div>
          <div class="list-body">
              <ul>
                  <li v-for="item in showList" :key="item.teamId" class="clearfix">
                      <div class="name left">
                        <span>{{ item.name }}</span>
                      </div>
                      <div class="income left">
                        <span>
                            {{item.realized > 0 ? '+' : ''}}{{ item.realized | numberNewFormatter(2) }}
                        </span>
                      </div>
                      <div class="incomeRate left" :class="[item.isTopByYieldRate ? 'top1' : '', item.isTwoByYieldRate ? 'top2' : '',  item.isThreeByYieldRate ? 'top3' : '',]">
                        <span>
                            <img v-if="item.isTopByYieldRate" class="crown" src="@/assets/active/team-pk/crown.png" alt="">
                            <img v-if="item.isTwoByYieldRate" class="crown" src="@/assets/active/team-pk/crown2.png" alt="">
                            <img v-if="item.isThreeByYieldRate" class="crown" src="@/assets/active/team-pk/crown3.png" alt="">
                            {{item.yieldRate > 0 ? '+' : ''}}{{ item.yieldRate * 100 | toDigit(2) }}%
                        </span>
                      </div>
                  </li>
              </ul>
          </div>
      </div>
      <div v-if="liveType === 'person'" class="list-wrapper person">
          <div class="list-head clearfix">
                <div class="name left">
                    <span>队员名称</span>
                </div>
                <div class="income left">
                    <sort-btn sortType='realized' sort-name='个人收益额' @sort='sortPersonListBy' :group-tag='sortPersonGroup' />
                </div>
                <div class="incomeRate left">
                    <sort-btn sortType='yieldRate' sort-name='个人收益率' @sort='sortPersonListBy' :group-tag='sortPersonGroup' />
                </div>
          </div>
          <div class="list-body">
              <ul>
                  <li v-for="item in showPersonList" :key="item.id" class="clearfix">
                      <div class="name left">
                        <div class="name-box">
                            <img class="ava" :src="item.memberInfo.headImg ? item.memberInfo.headImg : defaultImg" alt="" />
                            <p class="u-id">{{ item.memberInfo.jgzUserId }}</p>
                            <p class="u-name">{{ item.memberInfo.nickName ? item.memberInfo.nickName : '-' }}</p>
                        </div>
                      </div>
                      <div class="income left">
                        <span>
                            {{item.realized > 0 ? '+' : ''}}{{ item.realized | numberNewFormatter(2) }}
                        </span>
                      </div>
                      <div class="incomeRate left" :class="item.isTopByYieldRate ? 'max' : ''">
                        <span>
                            <img v-if="item.isTopByYieldRate" class="crown" src="@/assets/active/team-pk/crown.png" alt="">
                            {{item.yieldRate > 0 ? '+' : ''}}{{ item.yieldRate * 100 | toDigit(2) }}%
                        </span>
                      </div>
                  </li>
              </ul>
          </div>
      </div>
      <jgz-loading :loading-show='showLoading'></jgz-loading>
  </div>
</template>

<script>
import SortBtn from '@/components/SortButton.vue'
import JgzLoading from '@/components/JgzLoading.vue'
const actId = 306767
export default {
    name: 'TeamPkLive',
    data() {
        return {
            showLoading: false,
            currentTime: null,
            lastTime: null,
            beginTime: null,
            endTime: null,
            state: null,
            liveType: 'team',
            countDownObj: {},
            sort: 'realized',
            sortMode: 'desc',
            sortGroup: '',
            orginList: [],
            showList: [],

            sortPersonGroup: '',
            sortPerson: 'realized',
            sortPersonMode: 'desc',
            orginPersonList: [],
            showPersonList: [],
        }
    },
    components: {
        SortBtn,
        JgzLoading
    },
    computed: {
        defaultImg() { return this.$DefaultHead }
    },
    mounted() {
        this.getList()
        this.getPersonalList()
        setInterval(() => {
            this.currentTime = Math.round(new Date())
            this.computeCountDown()
        }, 1000);
    },
    methods: {
        //  获取赛况直播内容
        getList() {
            this.$MyAxios.get('/api/trade/teams/rank', {}, response => {
                if(response.code == 1) {
                    this.showLoading = false
                    const data = response.data[0]
                    this.state = data.busStateName
                    this.lastTime = data.awardUpdateDate
                    this.beginTime = data.busStartTimeOne
                    this.endTime = data.busEndTimeOne
                    this.orginList = data.ranks
                    this.showList = [...this.orginList]
                    this.currentTime = Math.round(new Date())
                    this.computeCountDown()
                }
            })
        },

        //  个人赛况
        getPersonalList() {
            this.$MyAxios.get('/api/trade/rank/teamMemTop', {
                params: {
                    actId: actId
                }
            }, response => {
                if(response.code == 1) {
                    this.showLoading = false
                    const data = response.data
                    this.orginPersonList = data
                    this.showPersonList = [...this.orginPersonList]
                }
            })
        },

        computeCountDown() {
            const diff = Math.floor((this.endTime - this.currentTime) / 1000)
            const day =  Math.floor(diff / 3600 / 24)
            const hour = Math.floor(diff % (3600 * 24) / 3600)
            const minute = Math.floor(diff % 3600 / 60)
            const second = Math.floor(diff % 60)
            this.countDownObj = {day, hour, minute, second}
        },
        //  排序操作
        sortListBy(sortObj) {
            this.sortGroup = sortObj.sort;
            this.sortMode = sortObj.sortMode;
            
            if(sortObj.sortMode) {
                this.sort = sortObj.sort;
                this.showList.sort((a, b) => {
                    if(this.sortMode === 'desc'){
                        return b[this.sort] - a[this.sort]
                    }else{
                        return a[this.sort] - b[this.sort]
                    }
                })
            }else{
                //  当归为默认的时候 排序也置空
                this.sort = '';
                this.showList = [...this.orginList]
            }
        },

        //  个人列表排序
        sortPersonListBy(sortObj) {
            this.sortPersonGroup = sortObj.sort;
            this.sortPersonMode = sortObj.sortMode;
            
            if(sortObj.sortMode) {
                this.sortPerson = sortObj.sort;
                this.showPersonList.sort((a, b) => {
                    if(this.sortPersonMode === 'desc'){
                        return b[this.sort] - a[this.sort]
                    }else{
                        return a[this.sort] - b[this.sort]
                    }
                })
            }else{
                //  当归为默认的时候 排序也置空
                this.sortPerson = '';
                this.showPersonList = [...this.orginPersonList]
            }
        }
        
    }
}
</script>

<style lang='less'>
#pk-live2 {
    padding-bottom: 100px;
    .title-box {
        height: 105px;
        line-height: 105px;
        text-align: center;
        img, span {
            vertical-align: middle;
        }
        img {
            margin: 0 5px;
            width: 44px;
            height: 24px;
        }
        span {
            font-size: 32px;
            color: #33333A;
            font-weight: bold;
        }
    }
    .timer-bar {
        width: 600px;
        height: 88px;
        background: linear-gradient(180deg,#ffa41f, #ff5c2a);
        border-radius: 44px;
        margin: 0 auto;
        color: #FFFFFF;
        line-height: 88px;
        margin-bottom: 50px;
        span {
            font-size: 32px;
            line-height: 36px;
            vertical-align: middle;
            margin-right: 10px;
        }
        .num {
            font-size: 48px;
            font-weight: bold;
            font-family: 'DINPro';
        }
    }
    .live-tab-wrapper {
        height: 88px;
        width: 600px;
        border-radius: 88px;
        background: #EBECF0;
        margin: 0 auto;
        margin-top: 60px;
        margin-bottom: 30px;
        button {
            border: none;
            background-color: #EBECF0;
            outline: none;
            color: #9598A6;
            font-size: 32px;
            font-weight: bold;
            height: 88px;
            width: 300px;
            border-radius: 88px;
            &.active {
                background: linear-gradient(180deg,#ffa41f, #ff5c2a);
                color: #FFFFFF;
            }
        }
    }
    .person-live-tip {
        font-size: 24px;
        color: #33333A;
        line-height: 36px;
        font-weight: 500;
        text-align: left;
        padding: 0 30px;
        margin-bottom: 30px;
    }
    .date {
        text-align: left;
        padding: 0 30px;
        font-size: 24px;
        line-height: 36px;
        margin-bottom: 20px;
        color: #9598A6;
    }
    .list-wrapper {
        text-align: right;
        span {
            display: inline-block;
        }
        .list-head {
            height: 70px;
            color: #9598A6;
            border-top: 1px solid #EBECF0;
            border-bottom: 1px solid #EBECF0;
            padding: 0 30px;
            line-height: 70px;
            font-size: 24px;
        }
        .list-body {
            padding: 0 20px;
            li {
                padding: 0 10px;
                border-bottom: 1px solid #EBECF0;
                height: 88px;
                line-height: 88px;
                overflow: hidden;
                color: #33333A;
                font-weight: 500;
                div {
                    position: relative;
                    span {
                        position: relative;
                    }
                    img.crown {
                        position: absolute;
                        top: 5px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 26px;
                        height: 20px;
                    }
                }
            }
            .name {
                overflow: hidden;
                position: relative;
                span {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
        .name {
            width: 50%;
            text-align: left;
        }
        .income {
            width: 24%;
            margin-right: 1%;
        }
        .incomeRate {
            width: 25%;
            &.top1 {
                color: #FB7115;
            }
            &.top2 {
                color: #9c9cEF;
            }
            &.top3 {
                color: #DF8C50;
            }
        }
    }
    .list-wrapper.person {
        .list-body li {
            height: 120px;
            &>div {
                height: 120px;
                line-height: 120px;
            }
            .name-box {
                position: relative;
                height: 120px;
                padding: 18px 0 18px 80px;
                p {
                    font-size: 28px;
                    font-weight: 500px;
                    line-height: 42px;
                }
                .u-id {
                   color: #33333A;
                }
                .u-name {
                    color: #9598A6;
                }
                img.ava {
                    position: absolute;
                    top: 30px;
                    left: 0;
                    width: 60px;
                    height: 60px;
                    border-radius: 30px;
                }
            }
        }
    }
}
</style>